import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { supabase } from "../../lib/supabase";
import { Input, Button } from "@dawa/ui";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const S = z.object({ email: z.string().email(), password: z.string().min(6) });

export default function Signup() {
  const nav = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<z.infer<typeof S>>({ resolver: zodResolver(S) });
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="auth-bg flex min-h-screen items-center justify-center p-4">
      <div className="flex w-full max-w-4xl flex-col items-center justify-center gap-8 md:flex-row">
        <div className="text-center text-2xl font-semibold text-white md:text-left md:w-1/2">
          Boostez votre SEO avec l'IA
        </div>
        <form
          className="w-full max-w-md space-y-4 rounded-xl bg-surface p-8 shadow-lg md:w-1/2"
          onSubmit={handleSubmit(async (v: z.infer<typeof S>) => {
            setError(null);
            const { error } = await supabase.auth.signUp(v);
            if (error) setError(error.message);
            else nav(`/auth/confirm?email=${encodeURIComponent(v.email)}`);
          })}
        >
          <h1 className="text-2xl font-bold">Créer un compte</h1>
          <Input placeholder="Email" {...register("email")} />
          {errors.email ? <p className="text-sm text-danger">{errors.email.message}</p> : null}
          <Input placeholder="Mot de passe" type="password" {...register("password")} />
          {errors.password ? (
            <p className="text-sm text-danger">{errors.password.message}</p>
          ) : null}
          {error && <p className="text-sm text-danger">{error}</p>}
          <Button type="submit" className="w-full" disabled={isSubmitting}>
            S'inscrire
          </Button>
        </form>
      </div>
    </div>
  );
}
